<template>
  <div class="response_table role_table">
    <table>
      <thead style="flex:0;">
        <tr>
          <th scope="col" class="name_role"> {{ translate('user.roles.role_name') }} </th>
          <th scope="col" class="description"> {{ translate('user.roles.description') }} </th>
          <th scope="col" class="permissions"> {{ translate('user.roles.permissions') }} </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(role, role_key) in role_list" :key="role_key" class="role">
          <td :data-label="translate('user.roles.role_name')" class="name_role">
            <span>{{ role.name }}</span>
          </td>
          <td :data-label="translate('user.roles.description')" class="description">
            <span>{{ role.description }}</span>
          </td>
          <td :data-label="translate('user.roles.permissions')" class="permissions">

            <span
              v-for="(permission, permission_key) in role.permissions"
              :key="permission_key"
              :title="permission_list[permission].description"
              :class="{ hidden_permission: permission_key > 5 && !show_permissions[role_key] }"
            >
              {{ permission_key !== role.permissions.length -1 ? permission + ',' : permission }}
            </span>

            <span
                v-if="role.permissions.length > 5"
                @click="show_permissions[role_key] = !show_permissions[role_key]"
                class="show_all_permissons"
            >
              {{ show_permissions[role_key] ? translate('click_to_hide') : translate('click_to_show') }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name: 'RoleList',
  props: ['role_list', 'permission_list'],
  data () {
    return {
      show_permissions: {}
    }
  },

  mounted() {
    for (let role in this.role_list) {
      this.$set(this.show_permissions, role, false)
    }
  }
}

</script>

<style lang="scss" scoped>
.response_table{
  font-size: 14px;
  &.role_table{
    height: 100%;
    padding: 0;
    .table_title{
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 0;
      height: 25px;
    }
    table{
      height: calc(100% - 33px);

      .name_role{
        text-align: left;
        width: 33%;
      }
      .description{
        width: 33%;
        text-align: left;
      }
      .permissions{
        width: 33%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        .show_all_permissons{
          cursor: pointer;
          font-weight: bold;
        }
        .hidden_permission{
          display: none;
        }
      }
    }
  }
}

</style>
